import React from 'react'

const IconArrowSwipeLeft = () => {
  return (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.00052 15.7115L0.289062 8.00003L8.00052 0.288574L9.12073 1.40878L2.52927 8.00003L9.12073 14.5913L8.00052 15.7115Z" />
    </svg>
  )
}

export default IconArrowSwipeLeft
